import {useCallback} from 'react';

import {useIsInLoadedReportContext} from '../../../pages/ReportPage/LoadedReportContext';
import {makeTrackEvent} from '../../../services/analytics/makeTrackEvent';

export type MoveRunsAction = 'Moved runs' | 'Created group';

export type MoveRunsEvent = {
  action: MoveRunsAction;
  location?: 'workspace' | 'report';
};

export const trackMoveRuns = makeTrackEvent<
  MoveRunsEvent,
  {
    action: {
      description: 'the menu option that was selected';
    };
    location: {
      description: 'where the action was triggered from';
    };
    _description: 'Tracks move runs interactions in run selector';
    _location: 'workspaces, reports';
    _motivation: 'track usage';
  }
>('Run selector move runs');

export const useTrackRunsWithLocation = () => {
  const isReport = useIsInLoadedReportContext();
  const trackMoveRunsWithLocation = useCallback(
    (action: MoveRunsAction) => {
      trackMoveRuns({action, location: isReport ? 'report' : 'workspace'});
    },
    [isReport]
  );
  return trackMoveRunsWithLocation;
};
